(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["city-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('city-finder')) {
    class CityFinder extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.select = this.querySelector('[data-city-select]');
        this.message = this.querySelector('[data-city-message]');
        if (!this.form || !this.select) return;

        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.form.addEventListener('submit', this.onSubmit);
        this.select.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        if (!this.form || !this.select) return;
        this.form.removeEventListener('submit', this.onSubmit);
        this.select.removeEventListener('change', this.onChange);
      }

      onSubmit(event) {
        event.preventDefault();
        const destination = this.select.value;

        if (!destination) {
          this.showMessage();
          return;
        }

        window.location.assign(destination);
      }

      onChange() {
        if (this.select.value) this.clearMessage();
      }

      showMessage() {
        this.select.setAttribute('aria-invalid', 'true');
        this.select.focus();
        if (!this.message) return;
        // Clear first so screen readers announce the message again on repeat clicks.
        this.message.textContent = '';
        window.setTimeout(() => {
          this.message.textContent = this.message.dataset.message;
        }, 50);
      }

      clearMessage() {
        this.select.removeAttribute('aria-invalid');
        if (this.message) this.message.textContent = '';
      }
    }

    customElements.define('city-finder', CityFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
